// extracted by mini-css-extract-plugin
export default {"content":"ExpectedWinInfoPopup_content__+vA8Z","footer":"ExpectedWinInfoPopup_footer__040On","modalWidth":"ExpectedWinInfoPopup_modalWidth__M7XR6"};